var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAiToolsSelector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4120_137990)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.8975 2.78125H9.89746C4.89746 2.78125 2.89746 4.78125 2.89746 9.78125V15.7812C2.89746 20.7812 4.89746 22.7812 9.89746 22.7812H15.8975C20.8975 22.7812 22.8975 20.7812 22.8975 15.7812V13.7812",
    stroke: "#FB4764",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8082 4.34147C21.5782 7.41147 18.4882 11.5915 15.9082 13.6615L14.3282 14.9215C14.1282 15.0715 13.9282 15.1915 13.6982 15.2815C13.6982 15.1315 13.6882 14.9815 13.6682 14.8215C13.5782 14.1515 13.2782 13.5215 12.7382 12.9915C12.1882 12.4415 11.5282 12.1315 10.8482 12.0415C10.6882 12.0315 10.5282 12.0215 10.3682 12.0315C10.4582 11.7815 10.5882 11.5515 10.7582 11.3615L12.0182 9.78147C14.0882 7.20147 18.2782 4.09147 21.3382 2.86147C21.8082 2.68147 22.2682 2.82147 22.5582 3.11147C22.8582 3.41147 22.9982 3.87147 22.8082 4.34147Z",
    stroke: "#FB4764",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7078 15.2698C13.7078 16.1498 13.3678 16.9898 12.7378 17.6298C12.2478 18.1198 11.5878 18.4598 10.7978 18.5598L8.82783 18.7698C7.75783 18.8898 6.83783 17.9798 6.95783 16.8898L7.16783 14.9198C7.35783 13.1698 8.81783 12.0498 10.3778 12.0198C10.5378 12.0098 10.6978 12.0198 10.8578 12.0298C11.5378 12.1198 12.1978 12.4298 12.7478 12.9798C13.2878 13.5198 13.5878 14.1398 13.6778 14.8098C13.6978 14.9698 13.7078 15.1298 13.7078 15.2698Z",
    stroke: "#FB4764",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.748 12.7587C16.748 10.6688 15.058 8.96875 12.958 8.96875",
    stroke: "#FB4764",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4120_137990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FB4764",
    transform: "translate(0.927734 0.78125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAiToolsSelector);
export default __webpack_public_path__ + "static/media/IcAIToolsSelector.c123f361d8e1df376566952fd534019e.svg";
export { ForwardRef as ReactComponent };